<div class="app-layout d-flex min-vh-100" [class.sidebar-collapsed]="sidebarCollapsed">
  <!-- Sidebar Navigation -->
  <app-sidebar
    [collapsed]="sidebarCollapsed"
    (toggleSidebar)="toggleSidebar()"
  ></app-sidebar>

  <!-- Main Content Area -->
  <div class="main-content flex-grow-1 d-flex flex-column vh-100 overflow-y-auto overflow-x-hidden position-relative">
    <!-- Top Bar -->
    <app-topbar (toggleSidebar)="toggleSidebar()"></app-topbar>

    <!-- Page Content -->
    <div class="content-wrapper flex-grow-1 d-flex flex-column position-relative px-4 px-lg-5 py-5">
      <router-outlet></router-outlet>
    </div>

    <!-- Footer -->
    <footer class="py-4 px-4 px-lg-5">
      <div class="d-flex flex-column flex-md-row justify-content-center justify-content-md-between align-items-center gap-2">
        <div class="d-flex align-items-center gap-2">
          <img src="assets/images/logo-icon.png" alt="ADN Logo" width="20" height="20" class="footer-logo" />
          <span class="footer-text">Proudly Made in the USA</span>
        </div>
        <span class="text-nowrap text-muted small">Version {{ appVersion }}</span>
      </div>
    </footer>
  </div>
</div>
